import { createContext, useContext } from 'react';
import { WidgetType } from '../../../types/api/ElementType';
import WidgetFrameContext from '../../../components/molecules/Widget/Context';

type WidgetContext = {
  widgetType: WidgetType;
  widgetId: string;
  uuid: string;
  header: boolean;
};
const WidgetContext = createContext<WidgetContext | undefined>(undefined);

export const useWidgetContext = () => {
  const newContext = useContext(WidgetContext);
  const legacyContext = useContext(WidgetFrameContext);
  if (newContext) {
    return newContext;
  }
  // this hook uses a fallback to the old Context that is still used in the ContentSection
  // the fallback should be removed after Content section is moved to new architecture
  if (legacyContext) {
    return {
      header: legacyContext.header,
      widgetId: legacyContext.widgetId,
      uuid: legacyContext.widgetUuid,
      widgetType: legacyContext.widgetElementType as unknown as WidgetType,
    };
  }
  throw Error('useWidgetContext is used without Provider');
};

export const WidgetContextProvider = WidgetContext.Provider;
